import { useEffect } from "react";
import { useLocation } from "react-router";
import {
	clearOpenCartFromNavigationCookie,
	isOpenCartCookiePending,
} from "./open-cart-from-navigation.cookie";

export const OPEN_CART_FROM_NAVIGATION_KEY = "da:open-cart";

let pendingOpenCart = false;
let openCartSignalConsumed = false;

export function markOpenCartFromNavigation(): void {
	pendingOpenCart = true;
	openCartSignalConsumed = false;
	try {
		sessionStorage.setItem(OPEN_CART_FROM_NAVIGATION_KEY, "1");
	} catch {
		// sessionStorage can throw in private mode; the in-memory flag is enough
	}
}

export function isOpenCartFromNavigationPending(): boolean {
	if (pendingOpenCart) {
		return true;
	}
	try {
		if (sessionStorage.getItem(OPEN_CART_FROM_NAVIGATION_KEY) === "1") {
			return true;
		}
	} catch {
		// ignore
	}
	return isOpenCartCookiePending();
}

export function clearOpenCartFromNavigation(): void {
	pendingOpenCart = false;
	openCartSignalConsumed = false;
	try {
		sessionStorage.removeItem(OPEN_CART_FROM_NAVIGATION_KEY);
	} catch {
		// ignore
	}
	clearOpenCartFromNavigationCookie();
}

function hasOpenCartState(state: unknown): boolean {
	return (
		!!state &&
		typeof state === "object" &&
		"openCart" in state &&
		Boolean((state as { openCart?: unknown }).openCart)
	);
}

export function useOpenCartFromNavigation(
	openCart: () => void,
	canOpen: boolean,
	isOpen: boolean,
) {
	const location = useLocation();

	useEffect(() => {
		const fromState = hasOpenCartState(location.state);
		const pending = isOpenCartFromNavigationPending();
		if (!fromState && !pending) {
			return;
		}
		if (isOpen && canOpen) {
			clearOpenCartFromNavigation();
			openCartSignalConsumed = true;
			return;
		}
		if (!canOpen) {
			return;
		}
		if (openCartSignalConsumed && !pending) {
			return;
		}
		openCart();
	}, [canOpen, isOpen, location.state, openCart]);
}
